'use strict';

const errors = {
  SCRIPT_LOAD_FAILED: {
    src: 79,
    eventId: 104,
    params: {
      app_id: 'app_id',
      script_name: 'script_name',
      script_url: 'script_url',
      time_spent: 'time_spent',
      error: 'error',
      ts: 'ts'
    }
  },
  INIT_APP_FOR_PAGE_FAILED: {
    src: 79,
    eventId: 106,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      error: 'error',
      ts: 'ts'
    }
  },
  CREATE_CONTROLLERS_FAILED: {
    src: 79,
    eventId: 108,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      controller_id: 'controller_id',
      time_spent: 'time_spent',
      error: 'error',
      ts: 'ts'
    }
  },
  PAGE_READY_FAILED: {
    src: 79,
    eventId: 111,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      controller_id: 'controller_id',
      controller_type: 'controller_type',
      error: 'error',
      ts: 'ts'
    }
  },
  PLATFORM_LIFECYCLE_UNHANDLED_EXCEPTION: {
    errorName: 'PLATFORM_LIFECYCLE_UNHANDLED_EXCEPTION',
    errorCode: 111033,
    severity: 'error',
    params: {
      errorMsg: 'errorMsg',
      stack: 'stack',
      line: 'line',
      column: 'column'
    }
  },
  PREFETCH_SCRIPT_EVAL_FAILED: {
    src: 79,
    eventId: 149,
    params: {
      script_url: 'script_url',
      time_since_load: 'time_spent',
      error: 'error',
      ts: 'ts'
    }
  },
  IMPORT_SCRIPT_WITHOUT_CACHEKILLER_FAILED: {
    src: 79,
    eventId: 158,
    params: {
      script_url: 'script_url',
      time_since_load: 'time_spent',
      error: 'error',
      ts: 'ts'
    }
  },
  PLATFORM_RENDER_ERROR: {
    src: 72,
    eventId: 310,
    endpoint: 'performance',
    params: {
      actionName: 'actionName',
      appId: 'appId',
      error: 'error',
      isServerSide: 'isServerSide',
      msid: 'msid',
      pageId: 'pageId',
      pageUrl: 'pageUrl',
      requestId: 'requestId',
      ts: 'ts',
      widgetId: 'widgetId',
      workerId: 'workerId',
      vsi: 'vsi'
    }
  }
};

module.exports = errors;
